export const engineeringPdfs = {
    "State Board": {
      Kannada: {
        syllabus: [
         
        ],
        notes: [
         
        ],
        papers: [
         
           
        ],
      },
      // Add more subjects...
    },
  };
  